<template>
	<div id="enterprise_detail"  v-title data-title="技术需求列表">
		<headerbar :curindex="5"></headerbar>
		<!-- 研究院需求列表 -->
		<div class="demandList" style="margin-top: 10px;" v-if="userdata.userType == 5">
		 <div class="whitebox">
				<div class="centerpage1">
					<div class="deman_title"><i class="messicon"></i><h3 class="fl">我发布的技术供给信息</h3><span class="fr">您一共发布{{tablelist1.length}}条技术供给信息</span></div>
					<table border="0" cellspacing="0" cellpadding="0" width="100%" class="pagetable1">
						<tr><th class="xuhaotd">序号</th><th>技术名称</th><th>技术类型</th><th>成熟度</th><th>行业分类</th><th>所属领域</th><th>主题分类</th><th>内容</th></tr>
						<tr v-for="(item,index) in tablelist1"><td>{{index+1}}</td><td><router-link target="_blank" class="curp" :to="'/demand?type=s&id='+item.id">{{item.title}}</router-link></td><td>{{item.techType}}</td><td>{{item.maturity}}</td><td>{{item.industry}}</td><td>{{item.notion}}</td><td>{{item.topicType}}</td><td><router-link :to="'/demand?type=s&id='+item.id" target="_blank" class="curp">详情</router-link></td></tr> 
					</table>
				</div> 
			</div>
			<div class="whitebox">
				<div class="centerpage1">
					<div class="deman_title"><i class="messicon"></i><h3 class="fl">相关技术需求信息</h3> <span class="fr">产业大脑为您找到{{tablelist2.length}}条匹配的技术需求信息</span></div>
					<div :class="showmorenode?'demandlist_hide_table showmorenode':'demandlist_hide_table'"> 
						<table border="0" cellspacing="0" cellpadding="0" width="100%" class="pagetable1">
							<tr><th class="xuhaotd">序号</th><th>技术名称</th><th>需求发布方</th><th>服务类型</th><th>行业分类</th><th>所属领域</th><th>所在地</th><th>预算</th><th>截止时间</th><th>内容</th></tr>
							<tr v-for="(item,index) in tablelist2" v-show="index < 5 || showmorenode"><td>{{index+1}}</td><td><router-link target="_blank" class="curp" :to="'/demand?type=d&id='+item.id">{{item.title}}</router-link></td>
							<td><span>{{item.publisher}}</span></td><td>{{item.serviceType}}</td><td>{{item.industry}}</td>
							<td>{{item.notion}}</td><td>{{item.area}}</td><td>{{item.budget}}</td><td>{{item.endDate}}</td><td><router-link :to="'/demand?type=d&id='+item.id" target="_blank" class="curp">详情</router-link></td></tr>  
						</table>
							<span v-text="showmorenode?'向上隐藏':'点击查看更多>>'" class="showmorenodebtn" @click="showmorenode=!showmorenode" v-show="tablelist2.length>5"></span>
					</div> 
				</div> 
			</div>
			<div class="whitebox">
				<div class="centerpage1">
					<div class="deman_title"><i class="messicon"></i><h3 class="fl">可能存在技术需求的企业</h3></div>
					<table border="0" cellspacing="0" cellpadding="0" width="100%" class="pagetable1">
						<tr><th class="xuhaotd">序号</th><th>企业名称</th><th>所属领域</th><th>注册资本</th><th>员工人数</th><th>地区</th></tr>
						<tr v-for="(item,index) in tablelist3"><td>{{index+1}}</td><td><router-link class="curp" :to="'/enterprises?id='+item.stockCode" target="_blank">{{item.title}}</router-link></td>
						<td>{{item.notion}}</td>
						<!-- <span class="curp" v-for="(notion,ind) in item.notionlist" @click="tagrouter('/enterpriseTag',leaderpagetype,'tag',item.id,item.name)">{{notion}}</span> -->
						<td>{{item.regCapital}}</td><td>{{item.insurePerson}}</td><td>{{item.area}}</td></tr> 
					</table> 
				</div> 
			</div> 
		</div>
		<!-- 企业供给列表 -->
		<div class="demandList" style="margin-top: 10px;" v-if="userdata.userType == 2 || userdata.userType == 3">
			<div class="whitebox">
				<div class="centerpage1">
					<div class="deman_title"><i class="messicon"></i><h3 class="fl">我发布的技术需求信息</h3><span class="fr">您一共发布{{tablelist1.length}}条技术需求信息</span></div> 
					<table border="0" cellspacing="0" cellpadding="0" width="100%" class="pagetable1">
						<tr><th class="xuhaotd">序号</th><th>技术名称</th><th>服务类型</th><th>行业分类</th><th>所属领域</th><th>所在地</th><th>预算</th><th>截止时间</th><th>内容</th></tr>
						<tr v-for="(item,index) in tablelist1" ><td>{{index+1}}</td><td><router-link :to="'/demand?type=d&id='+item.id" target="_blank" class="curp">{{item.title}}</router-link></td><td>{{item.serviceType}}</td><td>{{item.industry}}</td><td>{{item.notion}}</td><td>{{item.area}}</td><td>{{item.budget}}</td><td>{{item.endDate}}</td><td><router-link :to="'/demand?type=d&id='+item.id" target="_blank" class="curp">详情</router-link></td></tr>  
					</table> 
				</div> 
			</div>
		 <div class="whitebox">
				<div class="centerpage1">
					<div class="deman_title"><i class="messicon"></i><h3 class="fl">相关技术供给信息</h3><span class="fr">产业大脑为您找到{{tablelist2.length}}条匹配的技术供给信息</span></div>
					<div :class="showmorenode?'demandlist_hide_table showmorenode':'demandlist_hide_table'">
						<span v-text="showmorenode?'向上隐藏':'点击查看更多>>'" class="showmorenodebtn" @click="showmorenode=!showmorenode" v-show="tablelist2.length>5"></span>
						<table border="0" cellspacing="0" cellpadding="0" width="100%" class="pagetable1">
							<tr><th class="xuhaotd">序号</th><th>技术名称</th><th>技术发布方</th><th>技术类型</th><th>成熟度</th><th>行业分类</th><th>所属领域</th><th>主题分类</th><th>内容</th></tr>
							<tr v-for="(item,index) in tablelist2" v-show="index < 5 || showmorenode"><td>1</td><td><router-link target="_blank" class="curp" :to="'/demand?type=s&id='+item.id">{{item.title}}</router-link></td>
							<td><span>{{item.publisher}}</span></td><td>{{item.techType}}</td><td>{{item.maturity}}</td><td>{{item.industry}}</td><td>{{item.notion}}</td><td>{{item.topicType}}</td><td><router-link target="_blank" class="curp" :to="'/demand?type=s&id='+item.id">详情</router-link></td></tr>
						</table>
				</div> 
				</div> 
			</div> 
			<div class="whitebox">
				<div class="centerpage1">
					<div class="deman_title"><i class="messicon"></i><h3 class="fl">可能提供技术供给的创新机构</h3></div>
					<table border="0" cellspacing="0" cellpadding="0" width="100%" class="pagetable1">
						<tr><th class="xuhaotd">序号</th><th>创新机构名称</th><th>所属领域</th><th>专利量</th><th style="font-size: 14px;">发明（设计）人数量</th><th>有效专利量</th><th style="font-size: 14px;">有效发明专利数量(件)</th><th style="font-size: 14px;">实用新型专利总量</th><th>地区</th></tr>
						<tr v-for="(item,index) in tablelist3"><td>{{index+1}}</td><td><router-link class="curp" target="_blank" :to="'/resources-enterprises?id='+item.id">{{item.title}}</router-link></td><td>{{item.notion}}</td><td>{{item.patentNum}}</td><td>{{item.inventionNum}}</td><td>{{item.validPatentNum}}</td><td>{{item.validInventionNum}}</td><td>{{item.practicalNewTypePatentCount}}</td><td>{{item.area}}</td></tr> 
					</table> 
				</div> 
			</div> 
		</div>
		<footerbar></footerbar>
	</div>
</template>

<script>
	export default {
		name: 'demandList',
		data() {
			return { 
				userdata:{},
				showmorenode:false,
				locaytype:1,
				tablelist1:[],
				tablelist2:[],
				tablelist3:[], 
			}
		}, 
		beforeCreate() { },
		created() {
			// window.scrollTo(0,0); 
			this.getuserinfor(); 
		},
		mounted() {
			window.scrollTo(0, 0);   
		},
		methods: {
			getuserinfor(){
				// this.bus.$emit('loading',true);
				let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
				if(typeof(dataddd) == 'object'){
				this.userdata = dataddd;
				}else{
				this.userdata = JSON.parse(dataddd);
				}
				console.log(this.userdata.userType)
				this.locaytype=this.userdata.userType;
				this.getdemandlist();
			}, 
			getdemandlist(){
				var ajaxurl="",utype=this.locaytype;
				var _this=this;
				if(utype == 5){
					ajaxurl=this.$api.cyl.techsupply.list();
				}else if(utype == 2 || utype == 2){
					ajaxurl=this.$api.cyl.techdemand.list();
				}else{
					window.open('/')
				}
				this.$axios.get(ajaxurl,{headers:{AuthToken:this.userdata.token}}).then(function(res){
					console.log(res);
					if(!res.data.success){
						_this.tokenfailed('logout');
						return;
					}
					 _this.tablelist1=res.data.list;	
						if(utype == 5){
						_this.tablelist2=res.data.extend.relatedDemand; 
						var relateen=res.data.extend.relatedEnterprise;
						for(var i=0;i<relateen.length;i++){
							if(relateen[i].notion!=""){
								relateen[i].notionlist=relateen[i].notion.split(',');
								relateen[i].notioncodelist=relateen[i].notionCode.split(',');
							}else{
								relateen[i].notionlist=[];
								relateen[i].notioncodelist=[];
							}
						} 
						_this.tablelist3=relateen;
						console.log(relateen)
						}else if(utype == 2 || utype == 3){ 
							_this.tablelist2=res.data.extend.relatedSupply; 
							_this.tablelist3=res.data.extend.relatedAcademy; 
							
						}
					
					
					
				 // _this.baseinfor=res.data.data;
				 }).catch(function (error) {alert('error')}); 
				
				
			},
			
			
			
		}
	}
</script>

<style>
</style>
